import React from "react";
import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const includes = [
  "Full five-month program access",
  "Live weekly classes",
  "Practical workshops and business cases",
  "Monthly masterclasses",
  "Specialization track access",
  "AI and Digital Transformation module",
  "Capstone support",
  "Utiva Global MBA Certificate upon completion",
  "Access to five international university partners",
];

const corporateFactors = [
  "Participant count",
  "Customization",
  "Coaching support",
  "Reporting needs",
];

const MBAPricingSection = () => {
  return (
    <section
      className="bg-hire-tint-blue py-16 md:py-24 lg:py-28 px-4"
      id="investment"
    >
      <Animate.Fade bottom>
        <div className="container mx-auto mb-10 lg:mb-12">
          <div className="max-w-3xl">
            <p className="flex items-center gap-3 font-poppins text-primary text-sm font-extrabold tracking-widest uppercase mb-5">
              <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
              Program investment
            </p>
            <h2 className="font-poppins text-primary font-bold tracking-tight text-3xl md:text-4xl leading-tight mb-4">
              Choose the cohort that fits where you are.
            </h2>
            <p className="font-poppins text-gray text-sm m-0">
              Scholarship support of up to 50% is available for eligible
              applicants. Review the scholarship categories before completing
              enrollment.
            </p>
          </div>
        </div>
      </Animate.Fade>

      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-3.5 items-stretch">
        <Animate.Fade bottom>
          <article className="bg-white border border-hire-line rounded-3xl p-8 flex flex-col h-full shadow-course-card">
            <span className="font-poppins text-secondary text-xs font-extrabold tracking-widest">
              Individual · Africa
            </span>
            <h3 className="font-poppins text-primary font-bold text-xl mt-5 mb-2">
              Africa cohort
            </h3>
            <p className="font-poppins text-gray text-sm leading-relaxed min-h-[48px]">
              For self-sponsored professionals joining an open cohort.
            </p>
            <strong className="font-poppins text-primary tracking-tight text-4xl mt-5">
              ₦550,000
            </strong>
            <small className="font-poppins text-gray text-sm">
              per participant
            </small>
            <ul className="border-t border-hire-line grid gap-2.5 min-h-[265px] my-7 pt-5 list-none p-0">
              {includes.map((item) => (
                <li
                  key={item}
                  className="grid grid-cols-mba-list-24 gap-2.5 items-center text-gray font-poppins text-sm leading-snug"
                >
                  <span className="w-[22px] h-[22px] rounded-full bg-hire-tint-blue text-primary grid place-items-center text-xs">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <Link
              to="/mba/apply"
              className="mt-auto text-white bg-primary custom-btn px-7 py-4 text-center rounded-xl inline-flex items-center justify-center gap-3 font-poppins font-bold text-sm focus:outline-none"
            >
              Apply now{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </Link>
          </article>
        </Animate.Fade>

        <Animate.Fade bottom>
          <article className="bg-primary text-white border border-primary rounded-3xl p-8 flex flex-col h-full shadow-course-feature-lg">
            <span className="font-poppins text-secondary text-xs font-extrabold tracking-widest">
              Individual · Global
            </span>
            <h3 className="font-poppins text-white font-bold text-xl mt-5 mb-2">
              US / UK / Global cohort
            </h3>
            <p className="font-poppins text-blue-100 text-sm leading-relaxed min-h-[48px]">
              For professionals outside Africa seeking practical business
              education.
            </p>
            <strong className="font-poppins text-white tracking-tight text-4xl mt-5">
              $650
            </strong>
            <small className="font-poppins text-blue-100 text-sm">
              per participant
            </small>
            <ul className="border-t border-white/20 grid gap-2.5 min-h-[265px] my-7 pt-5 list-none p-0">
              {includes.map((item) => (
                <li
                  key={item}
                  className="grid grid-cols-mba-list-24 gap-2.5 items-center text-blue-100 font-poppins text-sm leading-snug"
                >
                  <span className="w-[22px] h-[22px] rounded-full bg-white/20 text-secondary grid place-items-center text-xs">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <Link
              to="/mba/apply"
              className="mt-auto text-primary bg-secondary custom-btn px-7 py-4 text-center rounded-xl inline-flex items-center justify-center gap-3 font-poppins font-bold text-sm focus:outline-none"
            >
              Apply now{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </Link>
          </article>
        </Animate.Fade>

        <Animate.Fade bottom>
          <article className="bg-white border border-hire-line rounded-3xl p-8 flex flex-col h-full shadow-course-card">
            <span className="font-poppins text-secondary text-xs font-extrabold tracking-widest">
              Corporate cohorts
            </span>
            <h3 className="font-poppins text-primary font-bold text-xl mt-5 mb-2">
              Custom pricing
            </h3>
            <p className="font-poppins text-gray text-sm leading-relaxed min-h-[48px]">
              For employee sponsorship, private cohorts and customized delivery.
            </p>
            <strong className="font-poppins text-primary tracking-tight text-3xl mt-5">
              Let’s talk
            </strong>
            <small className="font-poppins text-gray text-sm">
              pricing is scoped to your program
            </small>
            <div className="border-t border-hire-line flex flex-wrap content-start gap-2 min-h-[265px] my-7 pt-5">
              {corporateFactors.map((factor) => (
                <span
                  key={factor}
                  className="bg-hire-tint-yellow text-[#665226] rounded-full px-2.5 py-2 font-poppins text-sm h-fit"
                >
                  {factor}
                </span>
              ))}
            </div>
            <a
              href="mailto:business@utiva.co"
              className="mt-auto border border-primary text-primary custom-btn px-7 py-4 text-center rounded-xl inline-flex items-center justify-center gap-3 font-poppins font-bold text-sm focus:outline-none"
            >
              Contact Utiva Business{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </a>
          </article>
        </Animate.Fade>
      </div>

      <p className="container mx-auto font-poppins text-gray text-sm mt-4">
        Program fees and availability may change. Confirm current terms with
        Utiva before payment.
      </p>
    </section>
  );
};

export default MBAPricingSection;
